import {Component, OnInit, Input} from '@angular/core';
import {TransportesViagensService} from "./transportes-viagens.service";
import {TransportesViagensModel} from "./transportes-viagens.model";
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";

declare let swal: any;

@Component({
  selector: 'app-transportes-viagens-table',
  templateUrl: './transportes-viagens-table.component.html'
})
export class TransportesViagensTableComponent extends Components implements OnInit {

  @Input()
  id_transporte: string = '';

  viagens: TransportesViagensModel[] = [];

  constructor(
    private transportesViagensService: TransportesViagensService,
    public loginService: LoginService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    public func: Funcoes
  ) {
    super();
  }

  ngOnInit() {
    this.carregandoTabela = true;

    /*this.transportesViagensService.getPaginacao(1,this.itensPorPagina, ['navio', 'porto_descarga', 'porto_carregamento'], {"id_transporte":this.id_transporte})
      .subscribe(data => {
        this.viagens = data['Payload']['data'];
        this.totalItens = data['Payload']['total'];
        this.carregandoTabela = false;

        if (this.global.debug) {
          console.log(this.viagens);
        }
      },
      error => {
        this.func.showErro(error.json());
        this.carregandoTabela = false;
      });*/

    this.getPage(1);

  }

  delete(viagem) {
    let viagens = this.viagens;
    let transportesViagensService = this.transportesViagensService;

    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaDeletarNavio')+viagem.nome,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        if (self.global.debug) {
          console.log(viagens);
        }
        let index = viagens.indexOf(viagem);
        viagens.splice(index, 1);

        transportesViagensService.apagar(viagem.id_viagem)
          .subscribe(res => {
              self.viagens = viagens;
            },
            err => {
              // Revert the view back to its original state
              viagens.splice(index, 0, viagem);
              self.viagens = viagens;

              self.func.showErro(err.json());
            });

      });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    this.transportesViagensService.getPaginacao(pagina, this.itensPorPagina, ['transporte', 'local_descarga', 'local_carregamento'], {"id_transporte":this.id_transporte})
      .subscribe(data => {
          this.viagens = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;

          if (this.global.debug) {
            console.log(this.viagens);
          }
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });

  }

}



// WEBPACK FOOTER //
// ./src/app/transportes-viagens/transportes-viagens-table.component.ts